__turbopack_context__.v({
  "architectureDiagram": "VoLkrW_architectureDiagram",
  "claySpecimenGrid": "VoLkrW_claySpecimenGrid",
  "gridCaption": "VoLkrW_gridCaption",
  "imageGrid": "VoLkrW_imageGrid",
  "installerCaption": "VoLkrW_installerCaption",
  "installerImage": "VoLkrW_installerImage",
  "installerSection": "VoLkrW_installerSection",
  "installerWrapper": "VoLkrW_installerWrapper",
  "metaBlock": "VoLkrW_metaBlock",
  "metaGrid": "VoLkrW_metaGrid",
  "metaLabel": "VoLkrW_metaLabel",
  "metaLeft": "VoLkrW_metaLeft",
  "metaOverview": "VoLkrW_metaOverview",
  "metaRight": "VoLkrW_metaRight",
  "metaSection": "VoLkrW_metaSection",
  "metaText": "VoLkrW_metaText",
  "metaTools": "VoLkrW_metaTools",
  "page": "VoLkrW_page",
  "storySection": "VoLkrW_storySection",
  "tabsGrid": "VoLkrW_tabsGrid",
});
